import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";

import BubbleContainer from "./Bubble/BubbleContainer";

class BubblesListComponent extends PureComponent {
  static propTypes = {
    bubbles: PropTypes.array
  };

  render() {
    const { bubbles, checks, active } = this.props;

    return (
      <ul id="bubbles" className={checks.length > 0 || active ? "active" : ""}>
        {bubbles.map(bubble => {
          return (
            <li key={bubble.icon}>
              <BubbleContainer bubble={bubble} />
            </li>
          );
        })}
      </ul>
    );
  }
}

const mapStateToProps = state => ({
  checks: state.medias.listing.checks
});

export default connect(mapStateToProps)(BubblesListComponent);



// WEBPACK FOOTER //
// ./src/components/BubblesList/BubblesListComponent.js